import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useLanguage } from '../../../../contexts/LanguageContext';
import DealerDropdownBySap from '../../../../components/common/DealerDropdownBySap';

const UnpickedPartsReportFilters = ({ filters, onApplyFilters, onReset }) => {
    const { th } = useLanguage();
    const [filterOpen, setFilterOpen] = useState(true);
    const [localFilters, setLocalFilters] = useState({
        isDomestic: filters.isDomestic,
        dealer: null,
        dealerNo: filters.dealerNo,
        invoiceNo: filters.invoiceNo || '',
        deliveryNo: filters.deliveryNo || '',
        eFaturaNo: filters.eFaturaNo || ''
    });

    useEffect(() => {
        setLocalFilters((prev) => ({
            ...prev,
            isDomestic: filters.isDomestic,
            dealerNo: filters.dealerNo,
            dealer: filters.dealerNo ? prev.dealer : null,
            invoiceNo: filters.invoiceNo || '',
            deliveryNo: filters.deliveryNo || '',
            eFaturaNo: filters.eFaturaNo || ''
        }));
    }, [filters.isDomestic, filters.dealerNo, filters.invoiceNo, filters.deliveryNo, filters.eFaturaNo]);

    const domesticOptions = [
        { label: th('unpickedPartsReport.filter.all'), value: null },
        { label: th('unpickedPartsReport.filter.domestic'), value: true },
        { label: th('unpickedPartsReport.filter.foreign'), value: false }
    ];

    const handleDealerChange = (dealer) => {
        const dealerNo = dealer?.erpDealerNumber || dealer?.sapDealerId || null;
        setLocalFilters((prev) => ({
            ...prev,
            dealer: dealer && dealerNo ? dealer : null,
            dealerNo
        }));
    };

    const handleApply = () => {
        onApplyFilters({
            isDomestic: localFilters.isDomestic,
            dealerNo: localFilters.dealerNo,
            invoiceNo: localFilters.invoiceNo,
            deliveryNo: localFilters.deliveryNo,
            eFaturaNo: localFilters.eFaturaNo
        });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleApply();
        }
    };

    return (
        <div className="generic-table-filter">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button icon="pi pi-filter" label={th('common.filter')} onClick={() => setFilterOpen((prev) => !prev)} outlined={!filterOpen} />
                </div>
            </div>

            {filterOpen && (
                <div className="mt-3">
                    <Divider />
                    <div className="text-xl font-medium mb-3">{th('filter.advancedFilters')}</div>

                    <div className="flex flex-wrap gap-2" style={{ alignItems: 'end' }}>
                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('unpickedPartsReport.filter.isDomestic')}</label>
                                <Dropdown
                                    value={localFilters.isDomestic}
                                    options={domesticOptions}
                                    onChange={(e) => setLocalFilters((prev) => ({ ...prev, isDomestic: e.value }))}
                                    className="w-full"
                                    showClear
                                    placeholder={th('unpickedPartsReport.filter.isDomesticPlaceholder')}
                                />
                            </div>
                        </div>
                        <div className="flex-auto" style={{ minWidth: 240, maxWidth: 360 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('unpickedPartsReport.filter.dealer')}</label>
                                <DealerDropdownBySap
                                    value={localFilters.dealer}
                                    onChange={handleDealerChange}
                                    className="w-full"
                                    placeholder={th('unpickedPartsReport.filter.dealerPlaceholder')}
                                    rowCount={50}
                                />
                            </div>
                        </div>
                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('unpickedPartsReport.filter.invoiceNo')}</label>
                                <InputText
                                    value={localFilters.invoiceNo}
                                    onChange={(e) => setLocalFilters((prev) => ({ ...prev, invoiceNo: e.target.value }))}
                                    onKeyDown={handleKeyDown}
                                    className="w-full"
                                    placeholder={th('unpickedPartsReport.filter.invoiceNoPlaceholder')}
                                />
                            </div>
                        </div>
                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('unpickedPartsReport.filter.deliveryNo')}</label>
                                <InputText
                                    value={localFilters.deliveryNo}
                                    onChange={(e) => setLocalFilters((prev) => ({ ...prev, deliveryNo: e.target.value }))}
                                    onKeyDown={handleKeyDown}
                                    className="w-full"
                                    placeholder={th('unpickedPartsReport.filter.deliveryNoPlaceholder')}
                                />
                            </div>
                        </div>
                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('unpickedPartsReport.filter.eFaturaNo')}</label>
                                <InputText
                                    value={localFilters.eFaturaNo}
                                    onChange={(e) => setLocalFilters((prev) => ({ ...prev, eFaturaNo: e.target.value }))}
                                    onKeyDown={handleKeyDown}
                                    className="w-full"
                                    placeholder={th('unpickedPartsReport.filter.eFaturaNoPlaceholder')}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-start mt-3 gap-2">
                        <Button label={th('filter.reset')} icon="pi pi-refresh" className="p-button-outlined" onClick={onReset} />
                        <Button label={th('filter.apply')} icon="pi pi-search" onClick={handleApply} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default UnpickedPartsReportFilters;
